// Shapes one flat turn list into the rendered stream: day sections in the
// viewer's local timezone. Pure so it's testable; the API returns UTC
// timestamps and leaves this bucketing to the client on purpose (see
// console/routes/turns.py).

import type { Turn } from "@/lib/console";

export interface DaySection {
  key: string; // stable local-date key for React lists
  label: string; // "Today", "Yesterday", or a localized date
  items: Turn[];
}

export function groupByDay(turns: Turn[], now = new Date()): DaySection[] {
  const sections: DaySection[] = [];
  let current: DaySection | undefined;
  for (const turn of turns) {
    const day = new Date(turn.input_received_at);
    const key = `${day.getFullYear()}-${day.getMonth()}-${day.getDate()}`;
    if (current?.key !== key) {
      current = { key, label: dayLabel(day, now), items: [] };
      sections.push(current);
    }
    current.items.push(turn);
  }
  return sections;
}

function dayLabel(day: Date, now: Date): string {
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const daysAgo = Math.round((startOfDay(now).getTime() - startOfDay(day).getTime()) / 86_400_000);
  if (daysAgo === 0) return "Today";
  if (daysAgo === 1) return "Yesterday";
  return day.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    ...(day.getFullYear() !== now.getFullYear() && { year: "numeric" }),
  });
}
